import {defineStore} from "pinia";
import CustomFieldAPI from "@/api/CustomFieldAPI";

export const useCustomFieldStore = defineStore('custom-field', {
  state: () => ({
    data: [],
  }),
  actions: {
    clear() {
      this.data = [];
    },
    find(id) {
      return this.data.find(data => parseInt(data.id) === parseInt(id)) || null;
    },
    index(payload) {
      const { params } = payload;

      return new CustomFieldAPI().index(params)
      .then((response) => {
        this.data = response.data;
        return response;
      });
    },
  },
  persist: true,
});
